import React, { memo } from 'react';
import { RichTextBlock } from 'prismic-reactjs';
import Wrapper from '@components/wrapper.styled';
import Section from '@components/section';
import { ImageProps } from '@components/image';
import { defaultTheme } from '@styles/theme.styled';
import {
  Container,
  StyledTitle,
  StyledDescription,
  Divider,
  HorizontalDivider,
  StyledImage,
} from './text-section.styled';

export type TextAlign = 'left' | 'center';

export interface TextSectionProps {
  title?: string;
  quotedTitle?: boolean;
  description?: RichTextBlock[];
  image?: ImageProps;
  align?: TextAlign;
  emphasizedDescription?: boolean;
  backgroundColor?: keyof typeof defaultTheme.backgroundColors;
}

const getFontColor = (
  backgroundColor: keyof typeof defaultTheme.backgroundColors,
  hasDescription: boolean
): keyof typeof defaultTheme.colors => {
  if (backgroundColor === 'dark' || backgroundColor === 'primary') {
    return 'white';
  }
  return hasDescription ? 'black' : 'secondary';
};

const TextSection = memo(
  ({
    title,
    quotedTitle = false,
    description,
    align = 'center',
    image,
    emphasizedDescription = false,
    backgroundColor = 'white',
  }: TextSectionProps): JSX.Element => {
    console.log(image);
    return (
      <Section backgroundColor={backgroundColor}>
        <Wrapper>
          <Container align={align} emphasizedDescription={emphasizedDescription}>
            {emphasizedDescription && <Divider />}
            {title && description && <HorizontalDivider />}

            {title && (
              <StyledTitle
                type="title"
                tag="h2"
                fontSize="heading2"
                stringText={title}
                margin="none"
                fontColor={getFontColor(backgroundColor, !!description)}
                quoted={quotedTitle}
                isLongTitle={title.length > 160}
              />
            )}
            {description && (
              <StyledDescription
                richText={description}
                type="subheading"
                emphasized={emphasizedDescription}
                fontColor={
                  backgroundColor === 'dark' || backgroundColor === 'primary' ? 'light' : 'dark'
                }
              />
            )}

            {image && (
              <StyledImage
                url={image.url}
                alt={image.alt}
                gatsbyImageData={image.gatsbyImageData}
                objectFit="contain"
              />
            )}
          </Container>
        </Wrapper>
      </Section>
    );
  }
);

TextSection.displayName = 'TextSection';

export default TextSection;
